import request from '@/utils/request';
import { BASE_URL } from '@/utils/global';

// 查询审批列表
export function getFlowList(data?: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/flow/config/list.ac`,
    method: 'post',
    data,
  });
}

// 流程启停用
export function flowEnable(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/flow/config/enable.ac`,
    method: 'post',
    data,
  });
}

// 设置通知时效
export function flowDuration(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/flow/config/duration.ac`,
    method: 'post',
    data,
  });
}

// 保存流程定义
export function saveFlowDef(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/flow/def/save.ac`,
    method: 'post',
    data,
  });
}

// 查看流程定义
export function getFlowDef(code: string) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/flow/def/get.ac?flowCode=${code}`,
    method: 'post',
  });
}

// 查看流程定义
export function getFlowDefCo(params: Recordable, data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/flow/def/get.ac`,
    method: 'post',
    params,
    data,
  });
}
// 流程实例列表(审批列表)
export function flowIns(params: Recordable, data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/flow/ins/page.ac`,
    method: 'post',
    params,
    data,
  });
}
// 流程实例列表(审批列表统计)
export function flowInsExtra(params: Recordable, data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/flow/ins/statistics.ac`,
    method: 'post',
    params,
    data,
  });
}

// 节点任务 同意
export function consentFlowTask(data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/flow/task/consent.ac`,
    method: 'post',
    data,
  });
}

// 节点任务 终止(拒绝)
export function terminationFlowTask(data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/flow/task/termination.ac`,
    method: 'post',
    data,
  });
}
// 节点任务 批量同意
export function batchConsentFlowTask(data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/flow/task/consent/batch.ac`,
    method: 'post',
    data,
  });
}

// 节点任务 批量终止(拒绝)
export function batchTerminationFlowTask(data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/flow/task/termination/batch.ac`,
    method: 'post',
    data,
  });
}

// 流程路径图
export function flowChartPath(params: Recordable, data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/flow/chart/path.ac`,
    method: 'post',
    params,
    data,
  });
}

// 节点 发起审核
export function startFlowIns(data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/flow/ins/startIns.ac`,
    method: 'post',
    data,
  });
}
// 节点 撤销审核
export function deleteFlowIns(data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/flow/ins/deleteIns.ac`,
    method: 'post',
    data,
  });
}

// 获取流程支持的条件字段
export function getFlowCondition(params: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/flow/condition/get.ac`,
    method: 'post',
    params,
  });
}

// 保存流程定义
export function saveFlowDefV2(data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/flow/def/saveV2.ac`,
    method: 'post',
    data,
  });
}

// 查看流程定义
export function getFlowDefWithCondition(code: string) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/flow/def/getWithCondition.ac?flowCode=${code}`,
    method: 'post',
  });
}
